import React, {useEffect, useState} from "react";
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {FaCheck, FaTimes} from "react-icons/fa";
import GisUtils from "../utils/gis-utils.jsx";

const GisModalVideoCameras = ({modalVideoCameras, setModalVideoCameras, videoCamerasToOpen, setVideoCamerasToOpen}) => {
    const [selectedCameras, setSelectedCameras] = useState([]);
    const [limitReached, setLimitReached] = useState(false);

    const closeModal = () => {
        setModalVideoCameras(false);
        setVideoCamerasToOpen([]);
    }

    const openCameras = (cameras) => {
        setVideoCamerasToOpen([]);
        setModalVideoCameras(false);
        GisUtils.openMosaicCameras(cameras);
    }

    const selectCamera = (id, isVms, isChecked, cameraName, vmsId) => {
        if (isChecked) {
            for (let i = 0; i < selectedCameras.length; i++) {
                if (selectedCameras[i].id === id && selectedCameras[i].isVms === isVms) {
                    selectedCameras.splice(i, 1);
                    break;
                }
            }
        } else {
            selectedCameras.push({id, isVms, name: cameraName, vmsId});
        }

        setSelectedCameras([...selectedCameras]);
    }

    useEffect(() => {
        setLimitReached(selectedCameras.length >= 9);
    }, [selectedCameras]);

    return (
        <>
            <Modal open={modalVideoCameras} setOpen={closeModal} title="Mosaico: Selecione até 9 câmeras" isCloseClick={false} className={"w-6/12"}>
                <Modal.Body className={"p-2 h-80 overflow-auto"}>
                    <table className={"border border-[#ebebeb] w-full select-none"}>
                        <thead className="bg-[#f5f5f6]">
                            <tr>
                                <th className={"p-2 border border-[#ebebeb]"}>Câmera</th>
                                <th className={"p-2 border border-[#ebebeb]"} style={{width: "65px"}}>Ao vivo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                videoCamerasToOpen.map((camera, index) => {
                                    let live = true;
                                    let id = camera.id;
                                    let vmsId = camera.details.vmsConfigurationId;
                                    let isVms = true;
                                    const {title} = camera;

                                    if (id.includes('video-camera')) {
                                        live = camera.details.description.live;
                                        id = camera.details.description.id;
                                        isVms = false
                                    }

                                    const isChecked = selectedCameras.some(camera => camera.id === id && camera.isVms === isVms);
                                    const disabled = (limitReached && !isChecked) || !live;

                                    return(
                                        <tr key={index}>
                                            <td className={"p-2 border text-center border-[#ebebeb]"}>
                                                <InputCheckbox
                                                    id={`camera-${index}`}
                                                    label={title}
                                                    disabled={disabled}
                                                    checked={isChecked}
                                                    onChange={() => selectCamera(id, isVms, isChecked, title, vmsId)}
                                                />
                                            </td>
                                            <td className={"p-2 border text-center border-[#ebebeb]"}>
                                                <div className={"icons"}>
                                                    { live && <FaCheck color={"#31b131"}/>}
                                                    { !live && <FaTimes color={"#b4b4b4"}/> }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {
                        videoCamerasToOpen.length === 0 &&
                        <div className="alert alert-warning m-0 p-2 w-1000">
                            Nenhuma câmera ao vivo selecionada.
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer className={"p-1"}>
                    {
                        videoCamerasToOpen.length > 0 &&
                        <Button style={{width: "80px"}} onClick={() => openCameras(selectedCameras)}
                                disabled={selectedCameras.length === 0}>
                            Abrir
                        </Button>
                    }

                    {
                        videoCamerasToOpen.length === 0 &&
                        <Button onClick={() => setModalVideoCameras(false)}>
                            Ok
                        </Button>
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default GisModalVideoCameras;